[
  {
    "code": "es",
    "label": {
      "en": "Spanish",
      "es": "Español"
    },
    "order": 1,
    "is_active": true,
    "metadata": {
      "native_name": "Español",
      "direction": "ltr"
    }
  },
  {
    "code": "en",
    "label": {
      "en": "English",
      "es": "Inglés"
    },
    "order": 2,
    "is_active": true,
    "metadata": {
      "native_name": "English",
      "direction": "ltr"
    }
  },
  {
    "code": "fr",
    "label": {
      "en": "French",
      "es": "Francés"
    },
    "order": 3,
    "is_active": false,
    "metadata": {
      "native_name": "Français",
      "direction": "ltr"
    }
  },
  {
    "code": "de",
    "label": {
      "en": "German",
      "es": "Alemán"
    },
    "order": 4,
    "is_active": false,
    "metadata": {
      "native_name": "Deutsch",
      "direction": "ltr"
    }
  },
  {
    "code": "it",
    "label": {
      "en": "Italian",
      "es": "Italiano"
    },
    "order": 5,
    "is_active": false,
    "metadata": {
      "native_name": "Italiano",
      "direction": "ltr"
    }
  },
  {
    "code": "pt",
    "label": {
      "en": "Portuguese",
      "es": "Portugués"
    },
    "order": 6,
    "is_active": false,
    "metadata": {
      "native_name": "Português",
      "direction": "ltr"
    }
  },
  {
    "code": "nl",
    "label": {
      "en": "Dutch",
      "es": "Neerlandés"
    },
    "order": 7,
    "is_active": false,
    "metadata": {
      "native_name": "Nederlands",
      "direction": "ltr"
    }
  },
  {
    "code": "pl",
    "label": {
      "en": "Polish",
      "es": "Polaco"
    },
    "order": 8,
    "is_active": false,
    "metadata": {
      "native_name": "Polski",
      "direction": "ltr"
    }
  },
  {
    "code": "ru",
    "label": {
      "en": "Russian",
      "es": "Ruso"
    },
    "order": 9,
    "is_active": false,
    "metadata": {
      "native_name": "Русский",
      "direction": "ltr"
    }
  },
  {
    "code": "uk",
    "label": {
      "en": "Ukrainian",
      "es": "Ucraniano"
    },
    "order": 10,
    "is_active": false,
    "metadata": {
      "native_name": "Українська",
      "direction": "ltr"
    }
  },
  {
    "code": "zh",
    "label": {
      "en": "Chinese",
      "es": "Chino"
    },
    "order": 11,
    "is_active": false,
    "metadata": {
      "native_name": "中文",
      "direction": "ltr"
    }
  },
  {
    "code": "ja",
    "label": {
      "en": "Japanese",
      "es": "Japonés"
    },
    "order": 12,
    "is_active": false,
    "metadata": {
      "native_name": "日本語",
      "direction": "ltr"
    }
  },
  {
    "code": "ko",
    "label": {
      "en": "Korean",
      "es": "Coreano"
    },
    "order": 13,
    "is_active": false,
    "metadata": {
      "native_name": "한국어",
      "direction": "ltr"
    }
  },
  {
    "code": "ar",
    "label": {
      "en": "Arabic",
      "es": "Árabe"
    },
    "order": 14,
    "is_active": false,
    "metadata": {
      "native_name": "العربية",
      "direction": "rtl"
    }
  },
  {
    "code": "he",
    "label": {
      "en": "Hebrew",
      "es": "Hebreo"
    },
    "order": 15,
    "is_active": false,
    "metadata": {
      "native_name": "עברית",
      "direction": "rtl"
    }
  },
  {
    "code": "hi",
    "label": {
      "en": "Hindi",
      "es": "Hindi"
    },
    "order": 16,
    "is_active": false,
    "metadata": {
      "native_name": "हिन्दी",
      "direction": "ltr"
    }
  },
  {
    "code": "bn",
    "label": {
      "en": "Bengali",
      "es": "Bengalí"
    },
    "order": 17,
    "is_active": false,
    "metadata": {
      "native_name": "বাংলা",
      "direction": "ltr"
    }
  },
  {
    "code": "tr",
    "label": {
      "en": "Turkish",
      "es": "Turco"
    },
    "order": 18,
    "is_active": false,
    "metadata": {
      "native_name": "Türkçe",
      "direction": "ltr"
    }
  },
  {
    "code": "vi",
    "label": {
      "en": "Vietnamese",
      "es": "Vietnamita"
    },
    "order": 19,
    "is_active": false,
    "metadata": {
      "native_name": "Tiếng Việt",
      "direction": "ltr"
    }
  },
  {
    "code": "th",
    "label": {
      "en": "Thai",
      "es": "Tailandés"
    },
    "order": 20,
    "is_active": false,
    "metadata": {
      "native_name": "ไทย",
      "direction": "ltr"
    }
  },
  {
    "code": "id",
    "label": {
      "en": "Indonesian",
      "es": "Indonesio"
    },
    "order": 21,
    "is_active": false,
    "metadata": {
      "native_name": "Bahasa Indonesia",
      "direction": "ltr"
    }
  },
  {
    "code": "ms",
    "label": {
      "en": "Malay",
      "es": "Malayo"
    },
    "order": 22,
    "is_active": false,
    "metadata": {
      "native_name": "Bahasa Melayu",
      "direction": "ltr"
    }
  },
  {
    "code": "tl",
    "label": {
      "en": "Filipino",
      "es": "Filipino"
    },
    "order": 23,
    "is_active": false,
    "metadata": {
      "native_name": "Filipino",
      "direction": "ltr"
    }
  },
  {
    "code": "sv",
    "label": {
      "en": "Swedish",
      "es": "Sueco"
    },
    "order": 24,
    "is_active": false,
    "metadata": {
      "native_name": "Svenska",
      "direction": "ltr"
    }
  },
  {
    "code": "no",
    "label": {
      "en": "Norwegian",
      "es": "Noruego"
    },
    "order": 25,
    "is_active": false,
    "metadata": {
      "native_name": "Norsk",
      "direction": "ltr"
    }
  },
  {
    "code": "da",
    "label": {
      "en": "Danish",
      "es": "Danés"
    },
    "order": 26,
    "is_active": false,
    "metadata": {
      "native_name": "Dansk",
      "direction": "ltr"
    }
  },
  {
    "code": "fi",
    "label": {
      "en": "Finnish",
      "es": "Finés"
    },
    "order": 27,
    "is_active": false,
    "metadata": {
      "native_name": "Suomi",
      "direction": "ltr"
    }
  },
  {
    "code": "el",
    "label": {
      "en": "Greek",
      "es": "Griego"
    },
    "order": 28,
    "is_active": false,
    "metadata": {
      "native_name": "Ελληνικά",
      "direction": "ltr"
    }
  },
  {
    "code": "cs",
    "label": {
      "en": "Czech",
      "es": "Checo"
    },
    "order": 29,
    "is_active": false,
    "metadata": {
      "native_name": "Čeština",
      "direction": "ltr"
    }
  },
  {
    "code": "sk",
    "label": {
      "en": "Slovak",
      "es": "Eslovaco"
    },
    "order": 30,
    "is_active": false,
    "metadata": {
      "native_name": "Slovenčina",
      "direction": "ltr"
    }
  },
  {
    "code": "hu",
    "label": {
      "en": "Hungarian",
      "es": "Húngaro"
    },
    "order": 31,
    "is_active": false,
    "metadata": {
      "native_name": "Magyar",
      "direction": "ltr"
    }
  },
  {
    "code": "ro",
    "label": {
      "en": "Romanian",
      "es": "Rumano"
    },
    "order": 32,
    "is_active": false,
    "metadata": {
      "native_name": "Română",
      "direction": "ltr"
    }
  },
  {
    "code": "bg",
    "label": {
      "en": "Bulgarian",
      "es": "Búlgaro"
    },
    "order": 33,
    "is_active": false,
    "metadata": {
      "native_name": "Български",
      "direction": "ltr"
    }
  },
  {
    "code": "hr",
    "label": {
      "en": "Croatian",
      "es": "Croata"
    },
    "order": 34,
    "is_active": false,
    "metadata": {
      "native_name": "Hrvatski",
      "direction": "ltr"
    }
  },
  {
    "code": "sl",
    "label": {
      "en": "Slovenian",
      "es": "Esloveno"
    },
    "order": 35,
    "is_active": false,
    "metadata": {
      "native_name": "Slovenščina",
      "direction": "ltr"
    }
  },
  {
    "code": "sr",
    "label": {
      "en": "Serbian",
      "es": "Serbio"
    },
    "order": 36,
    "is_active": false,
    "metadata": {
      "native_name": "Српски",
      "direction": "ltr"
    }
  },
  {
    "code": "lt",
    "label": {
      "en": "Lithuanian",
      "es": "Lituano"
    },
    "order": 37,
    "is_active": false,
    "metadata": {
      "native_name": "Lietuvių",
      "direction": "ltr"
    }
  },
  {
    "code": "lv",
    "label": {
      "en": "Latvian",
      "es": "Letón"
    },
    "order": 38,
    "is_active": false,
    "metadata": {
      "native_name": "Latviešu",
      "direction": "ltr"
    }
  },
  {
    "code": "et",
    "label": {
      "en": "Estonian",
      "es": "Estonio"
    },
    "order": 39,
    "is_active": false,
    "metadata": {
      "native_name": "Eesti",
      "direction": "ltr"
    }
  },
  {
    "code": "ca",
    "label": {
      "en": "Catalan",
      "es": "Catalán"
    },
    "order": 40,
    "is_active": false,
    "metadata": {
      "native_name": "Català",
      "direction": "ltr"
    }
  },
  {
    "code": "gl",
    "label": {
      "en": "Galician",
      "es": "Gallego"
    },
    "order": 41,
    "is_active": false,
    "metadata": {
      "native_name": "Galego",
      "direction": "ltr"
    }
  },
  {
    "code": "eu",
    "label": {
      "en": "Basque",
      "es": "Euskera"
    },
    "order": 42,
    "is_active": false,
    "metadata": {
      "native_name": "Euskara",
      "direction": "ltr"
    }
  }
]
